import { uiToggleConfigs } from './constants'
import { useWidgetStore } from '@/store'

export function chatOpenTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_OPEN_EVENT = new CustomEvent('virtualAssistant:open')
    console.log('Event dispatched to open chatbot window!!')
    document.dispatchEvent(CHATBOT_OPEN_EVENT)
  }
}

export function chatConnectedTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_CONNECTED_EVENT = new CustomEvent('virtualAssistant:connected')
    console.log('Event dispatched to chatbot connected!!')
    document.dispatchEvent(CHATBOT_CONNECTED_EVENT)
  }
}

export function chatContinuedTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_CONTINUED_EVENT = new CustomEvent('virtualAssistant:continued')
    console.log('Event dispatched to chatbot continued!!')
    document.dispatchEvent(CHATBOT_CONTINUED_EVENT)
  }
}

export function chatbotSelectTopicTracking (data) {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_SELECT_TOPIC_EVENT = new CustomEvent('virtualAssistant:selectTopic', { detail: data })
    console.log('Event dispatched to chatbot select topic!!')
    document.dispatchEvent(CHATBOT_SELECT_TOPIC_EVENT)
  }
}

export function chatSuccessfulTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_SUCCESSFUL_EVENT = new CustomEvent('virtualAssistant:successful')
    console.log('Event dispatched to chatbot successful!!')
    document.dispatchEvent(CHATBOT_SUCCESSFUL_EVENT)
  }
}

export function chatFailureTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_FAILURE_EVENT = new CustomEvent('virtualAssistant:failure')
    console.log('Event dispatched to chatbot failure!!')
    document.dispatchEvent(CHATBOT_FAILURE_EVENT)
  }
}

export function chatCompletedTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_COMPLETED_EVENT = new CustomEvent('virtualAssistant:completed')
    console.log('Event dispatched to chatbot completed!!')
    document.dispatchEvent(CHATBOT_COMPLETED_EVENT)
  }
}

export function chatCloseTracking () {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_CLOSE_EVENT = new CustomEvent('virtualAssistant:close')
    console.log('Event dispatched to chatbot close!!')
    document.dispatchEvent(CHATBOT_CLOSE_EVENT)
  }
}

export function agentHandoffTracking (data) {
  const store = useWidgetStore()
  if (uiToggleConfigs.isAnalyticsEnabled && !store.darkProdFlag) {
    const CHATBOT_AGENT_HANDOFF_EVENT = new CustomEvent('genesys:chatTransfer', { agentType: data })
    console.log('Event dispatched to chatbot agent handoff!! with agent type: ', data)
    document.dispatchEvent(CHATBOT_AGENT_HANDOFF_EVENT)
  }
}
